import { z } from 'zod';
export const SESSION_COOKIE = 'studio_session';
/** Readable by the SPA on purpose: it is the client half of the double-submit pair. */
export const CSRF_COOKIE = 'studio_csrf';
export const SESSION_LIFETIME_MS = 30 * 24 * 60 * 60 * 1000;
export const LoginRequestSchema = z.object({ password: z.string().min(1) });
export const SessionResponseSchema = z.object({
    authenticated: z.literal(true),
    expiresAt: z.string().min(1),
    csrfToken: z.string().min(1),
});
//# sourceMappingURL=session.js.map